import { Rarity, Sport } from '@sorare/core/src/__generated__/globalTypes';
import type { PrintablePlayerSortName } from '@sorare/core/src/contexts/config';
import type { FilterWidget, FiltersGroup } from '@sorare/core/src/lib/filters';

import { SORTS as FOOTBALL_SORTS } from '#src/searchCards/football/sorts.ts';
import { SORTS as BASEBALL_SORTS } from '#src/searchCards/mlb/sorts.ts';
import { SORTS as NBA_SORTS } from '#src/searchCards/nba/sorts.ts';
import {
  scoutingCenterMarketDropdownFilters as BASEBALL_DROPDOWN_FILTERS,
  scoutingCenterMarketFilters as BASEBALL_FILTERS,
} from '#src/searchCommonPlayer/filtersGroup/baseball.tsx';
import {
  scoutingCenterBackendMarketDropdownFilters as FOOTBALL_BACKEND_DROPDOWN_FILTERS,
  scoutingCenterBackendMarketFilters as FOOTBALL_BACKEND_FILTERS,
  scoutingCenterMarketDropdownFilters as FOOTBALL_DROPDOWN_FILTERS,
  scoutingCenterMarketFilters as FOOTBALL_FILTERS,
} from '#src/searchCommonPlayer/filtersGroup/football.tsx';
import {
  scoutingCenterBackendMarketDropdownFilters as NBA_BACKEND_DROPDOWN_FILTERS,
  scoutingCenterBackendMarketFilters as NBA_BACKEND_FILTERS,
  scoutingCenterMarketDropdownFilters as NBA_DROPDOWN_FILTERS,
  scoutingCenterMarketFilters as NBA_FILTERS,
} from '#src/searchCommonPlayer/filtersGroup/nba.tsx';

export const SCOUTING_CENTER_OWNED_CARDS_RARITIES = [
  Rarity.limited,
  Rarity.rare,
  Rarity.super_rare,
  Rarity.unique,
];

type ScoutingCenterSportConfig = {
  sorts: PrintablePlayerSortName[];
  filters: FiltersGroup[];
  dropdownFilters: FilterWidget[];
  backendCardFilters?: FiltersGroup[];
  backendDropdownFilters?: FilterWidget[];
};

export const SCOUTING_CENTER_CONFIG_BY_SPORT: Record<
  Sport,
  ScoutingCenterSportConfig
> = {
  [Sport.FOOTBALL]: {
    sorts: FOOTBALL_SORTS,
    filters: FOOTBALL_FILTERS,
    dropdownFilters: FOOTBALL_DROPDOWN_FILTERS,
    backendCardFilters: FOOTBALL_BACKEND_FILTERS,
    backendDropdownFilters: FOOTBALL_BACKEND_DROPDOWN_FILTERS,
  },
  [Sport.NBA]: {
    sorts: NBA_SORTS,
    filters: NBA_FILTERS,
    dropdownFilters: NBA_DROPDOWN_FILTERS,
    backendCardFilters: NBA_BACKEND_FILTERS,
    backendDropdownFilters: NBA_BACKEND_DROPDOWN_FILTERS,
  },
  [Sport.BASEBALL]: {
    sorts: BASEBALL_SORTS,
    filters: BASEBALL_FILTERS,
    dropdownFilters: BASEBALL_DROPDOWN_FILTERS,
  },
};
